import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-981bc6ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "autoEditorView__contentWrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "autoEditorView__uploadWrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请上传行驶证", -1))
const _hoisted_6 = { class: "autoEditorView__uploadControl" }
const _hoisted_7 = { class: "autoEditorView__uploadCanvas" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["disabled", "value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"center"} }, "支持 jpg / jpeg / png 格式，大小不超过5M", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  class: "fl-row",
  style: {"width":"100%","padding":"4px 0"}
}
const _hoisted_13 = { style: {"color":"red"} }
const _hoisted_14 = {
  class: "fl-row",
  style: {"padding":"4px 0 3px"}
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkboxWidth",
  style: {"color":"#999"}
}, " 开启时，员工加油时需进行车辆验证 ", -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "descText"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "checkboxWidth" }
const _hoisted_26 = { class: "checkboxWidth" }
const _hoisted_27 = { class: "checkboxWidth" }
const _hoisted_28 = { class: "checkboxWidth" }
const _hoisted_29 = {
  class: "fl-row-center",
  style: {"padding-bottom":"40px"}
}
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_enterprise_input = _resolveComponent("app-enterprise-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_app_input_number = _resolveComponent("app-input-number")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_QuestionCircleFilled = _resolveComponent("QuestionCircleFilled")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    class: "autoEditorView",
    width: "620",
    placement: "right",
    title: _ctx.drawerTitle,
    closable: true,
    visible: _ctx.drawerVisible,
    "destroy-on-close": true,
    onClose: _ctx.onCloseDrawer
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          ref: "formRef",
          class: "autoEditorView__content",
          model: _ctx.formData,
          rules: _ctx.formRules,
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_section, {
              "allow-edit": "",
              editing: _ctx.basicEditing,
              "edit-state": !(_ctx.editingBlock && _ctx.editingBlock !== 'basic'),
              "hide-controls": _ctx.actionType === 'create',
              onEdit: _cache[16] || (_cache[16] = ($event: any) => (_ctx.editingBlock = 'basic')),
              onCancel: _ctx.onCancelEditBlock,
              onSubmit: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "公司",
                  name: "enterpriseId"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.enterpriseName), 513), [
                      [_vShow, _ctx.actionType !== 'create']
                    ]),
                    _withDirectives(_createElementVNode("div", null, [
                      _createVNode(_component_app_enterprise_input, {
                        value: _ctx.formData.enterpriseId,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.enterpriseId) = $event)),
                        "disable-in-open": ""
                      }, null, 8, ["value"])
                    ], 512), [
                      [_vShow, _ctx.actionType === 'create']
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "名称",
                  name: "vehicleName"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.vehicleName), 513), [
                      [_vShow, !_ctx.basicEditing]
                    ]),
                    _withDirectives(_createVNode(_component_a_input, {
                      value: _ctx.formData.vehicleName,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.vehicleName) = $event)),
                      maxlength: 15,
                      placeholder: "请输入内容",
                      "allow-clear": ""
                    }, null, 8, ["value"]), [
                      [_vShow, _ctx.basicEditing]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "车辆分组",
                  name: "vehicleGroup"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.vehicleGroupName || '--'), 513), [
                      [_vShow, !_ctx.basicEditing]
                    ]),
                    _withDirectives(_createVNode(_component_a_select, {
                      value: _ctx.formData.vehicleGroup,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.vehicleGroup) = $event)),
                      "dropdown-style": { maxHeight: '200px', overflow: 'auto' },
                      "show-search": "",
                      "filter-option": (input, option) => option.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_a_select_option, {
                          key: null,
                          value: null
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("未分组")
                          ]),
                          _: 1
                        })),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleGroupList, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.id,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.groupName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "filter-option"]), [
                      [_vShow, _ctx.basicEditing]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "车类型",
                  name: "carType"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.carType === 0 ? '公车' : _ctx.formData.carType === 1 ? '私车' : '--'), 513), [
                      [_vShow, !_ctx.basicEditing]
                    ]),
                    _withDirectives(_createVNode(_component_a_radio_group, {
                      value: _ctx.formData.carType,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.carType) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("私车")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("公车")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"]), [
                      [_vShow, _ctx.basicEditing]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "行驶证",
                  name: "permitUrlKey"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.basicEditing && _ctx.formData.permitUrl)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "autoEditorView__uploadCanvas",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$vp(_ctx.formData.permitUrl)))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.formData.permitUrl,
                            alt: "行驶证"
                          }, null, 8, _hoisted_2)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.basicEditing && !_ctx.formData.permitUrl)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "无"))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode(_component_a_spin, { spinning: _ctx.drivingLicenseUploading }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _hoisted_5,
                          _createElementVNode("div", _hoisted_6, [
                            _withDirectives(_createElementVNode("p", _hoisted_7, [
                              (_ctx.formData.permitUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.formData.permitUrl,
                                    alt: "行驶证"
                                  }, null, 8, _hoisted_8))
                                : _createCommentVNode("", true)
                            ], 512), [
                              [_vShow, _ctx.formData.permitUrlKey]
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["autoEditorView__virtualControl", { hide: _ctx.formData.permitUrlKey }])
                            }, [
                              _createVNode(_component_app_icon, { type: "upload" })
                            ], 2),
                            _createElementVNode("input", {
                              type: "file",
                              disabled: _ctx.drivingLicenseUploading,
                              name: "drivingLicense",
                              accept: "image/jpeg,image/png",
                              value: _ctx.drivingLicenseFile,
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChooseDrivingLicenseImage($event)))
                            }, null, 40, _hoisted_9)
                          ]),
                          _hoisted_10
                        ])
                      ]),
                      _: 1
                    }, 8, ["spinning"]), [
                      [_vShow, _ctx.basicEditing]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "车牌号码",
                  class: "autoEditorView__cardInfo",
                  name: "licensePlate"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.basicEditing)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(`${_ctx.formData.licensePlate ? _ctx.formData.vehicleNoPefix + _ctx.formData.licensePlate : "无"}`), 1))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_select, {
                        value: _ctx.formData.vehicleNoPefix,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.vehicleNoPefix) = $event)),
                        style: {"width":"80px","min-width":"80px","margin-right":"5px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinceTemp, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item,
                              value: item
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createVNode(_component_a_input, {
                        value: _ctx.formData.licensePlate,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.licensePlate) = $event)),
                        maxlength: 7,
                        placeholder: "车牌号码",
                        "allow-clear": "",
                        style: {"flex-grow":"1"}
                      }, null, 8, ["value"])
                    ], 512), [
                      [_vShow, _ctx.basicEditing]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "车辆识别代号",
                  name: "vin"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.vin ? _ctx.formData.vin : "无"), 513), [
                      [_vShow, !_ctx.basicEditing]
                    ]),
                    _withDirectives(_createVNode(_component_a_input, {
                      value: _ctx.formData.vin,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.vin) = $event)),
                      maxlength: 17,
                      placeholder: "车辆识别代号",
                      "allow-clear": ""
                    }, null, 8, ["value"]), [
                      [_vShow, _ctx.basicEditing]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_13, "车牌号码或车辆识别代号必填其中一项", 512), [
                      [_vShow, _ctx.basicEditing && _ctx.energyType !== 2]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "品牌",
                  name: "vehicleBrand"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.vehicleBrandName ? _ctx.formData.vehicleBrandName: "无"), 513), [
                      [_vShow, !_ctx.basicEditing]
                    ]),
                    _withDirectives(_createVNode(_component_a_select, {
                      value: _ctx.formData.vehicleBrand,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.vehicleBrand) = $event)),
                      "show-search": "",
                      "filter-option": _ctx.filterOption
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("请选择")
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandList, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: idx,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "filter-option"]), [
                      [_vShow, _ctx.basicEditing]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "型号",
                  name: "model"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.model ? _ctx.formData.model : "无"), 513), [
                      [_vShow, !_ctx.basicEditing]
                    ]),
                    _withDirectives(_createVNode(_component_a_input, {
                      value: _ctx.formData.model,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.model) = $event)),
                      maxlength: 21,
                      placeholder: "型号",
                      "allow-clear": ""
                    }, null, 8, ["value"]), [
                      [_vShow, _ctx.basicEditing]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "车辆所有人",
                  name: "owner"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.owner ? _ctx.formData.owner : "无"), 513), [
                      [_vShow, !_ctx.basicEditing]
                    ]),
                    _withDirectives(_createVNode(_component_a_input, {
                      value: _ctx.formData.owner,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.owner) = $event)),
                      maxlength: 32,
                      placeholder: "车辆所有人",
                      "allow-clear": ""
                    }, null, 8, ["value"]), [
                      [_vShow, _ctx.basicEditing]
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.energyType !== 2)
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 0,
                      label: "排量",
                      name: "displacement"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.displacement ? _ctx.formData.displacement : "无"), 513), [
                          [_vShow, !_ctx.basicEditing]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_select, {
                            value: _ctx.formData.capacityUnit,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.capacityUnit) = $event)),
                            style: {"width":"80px","margin-right":"10px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 'T' }, {
                                default: _withCtx(() => [
                                  _createTextVNode("T系列")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 'L' }, {
                                default: _withCtx(() => [
                                  _createTextVNode("L系列")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _withDirectives(_createVNode(_component_a_select, {
                            value: _ctx.formData.displacement,
                            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.displacement) = $event)),
                            class: "someSele",
                            style: {"width":"230px"},
                            options: _ctx.capacityListT,
                            onChange: _ctx.handleCapacity
                          }, null, 8, ["value", "options", "onChange"]), [
                            [_vShow, _ctx.formData.capacityUnit === 'T']
                          ]),
                          _withDirectives(_createVNode(_component_a_select, {
                            value: _ctx.formData.displacement,
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.displacement) = $event)),
                            class: "someSele",
                            style: {"width":"230px"},
                            options: _ctx.capacityListL,
                            onChange: _ctx.handleCapacity
                          }, null, 8, ["value", "options", "onChange"]), [
                            [_vShow, _ctx.formData.capacityUnit === 'L']
                          ])
                        ], 512), [
                          [_vShow, _ctx.basicEditing]
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_a_form_item, {
                  label: "油耗（L/100km）",
                  name: "oilConsumption"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.oilConsumption ? _ctx.formData.oilConsumption : "无"), 513), [
                      [_vShow, !_ctx.basicEditing]
                    ]),
                    _withDirectives(_createVNode(_component_app_input_number, {
                      value: _ctx.formData.oilConsumption,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.oilConsumption) = $event)),
                      placeholder: "油耗（L/100km）",
                      disabled: !_ctx.formData.canEditOilConsumption
                    }, null, 8, ["value", "disabled"]), [
                      [_vShow, _ctx.basicEditing]
                    ])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.isScheduleModel]
                ]),
                _createVNode(_component_a_form_item, { label: "交强险照片" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, [
                      (_ctx.formData.compulsoryInsuranceUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.formData.compulsoryInsuranceUrl
                          }, null, 8, _hoisted_15))
                        : (_openBlock(), _createElementBlock("span", _hoisted_16, "无"))
                    ], 512), [
                      [_vShow, !_ctx.basicEditing]
                    ]),
                    _withDirectives(_createElementVNode("div", null, [
                      _createVNode(_component_a_upload, {
                        "file-list": _ctx.fileList,
                        accept: ".png, .jpg, .jpeg",
                        "list-type": "picture-card",
                        "custom-request": _ctx.customRequest,
                        remove: _ctx.removeRequest,
                        onPreview: _ctx.handlePreview
                      }, {
                        default: _withCtx(() => [
                          (_ctx.fileList.length < 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_component_plus_outlined),
                                _hoisted_18
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["file-list", "custom-request", "remove", "onPreview"])
                    ], 512), [
                      [_vShow, _ctx.basicEditing]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["editing", "edit-state", "hide-controls", "onCancel", "onSubmit"]),
            _createVNode(_component_app_section, {
              title: "车辆限制",
              "allow-edit": "",
              editing: _ctx.limitEditing,
              "edit-state": !(_ctx.editingBlock && _ctx.editingBlock !== 'limit'),
              "hide-controls": _ctx.actionType === 'create',
              onEdit: _cache[26] || (_cache[26] = ($event: any) => (_ctx.editingBlock = 'limit')),
              onCancel: _ctx.onCancelEditBlock,
              onSubmit: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "车辆验证",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, [
                      _withDirectives(_createVNode(_component_a_tag, { color: "green" }, {
                        default: _withCtx(() => [
                          _createTextVNode("开启")
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.formData.ocrFlag]
                      ]),
                      _withDirectives(_createVNode(_component_a_tag, { color: "red" }, {
                        default: _withCtx(() => [
                          _createTextVNode("关闭")
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, !_ctx.formData.ocrFlag]
                      ])
                    ], 512), [
                      [_vShow, _ctx.actionType === 'view' && !_ctx.limitEditing]
                    ]),
                    _withDirectives(_createVNode(_component_a_radio_group, {
                      value: _ctx.formData.ocrFlag,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.ocrFlag) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("开启")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("关闭")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"]), [
                      [_vShow, !(_ctx.actionType === 'view' && !_ctx.limitEditing)]
                    ]),
                    _hoisted_19
                  ]),
                  _: 1
                }),
                (_ctx.energyType !== 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_a_form_item, {
                        label: "油品限制",
                        name: "oilProhibitFlag",
                        rules: [{required: true, validator: _ctx.oilProhibitValidator, trigger: 'change'}]
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", null, [
                            _createElementVNode("div", null, [
                              (!_ctx.formData.oilProhibitFlag)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "不限制"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                    (_ctx.formData.qyNames.length && _ctx.oilNosList.qy.length)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, "汽油：" + _toDisplayString(_ctx.formData.qyNames.join(',')), 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.formData.cyNames.length && _ctx.oilNosList.cy.length)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "柴油：" + _toDisplayString(_ctx.formData.cyNames.join(',')), 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.formData.trqNames.length && _ctx.oilNosList.trq.length)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "天然气：" + _toDisplayString(_ctx.formData.trqNames.join(',')), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                            ])
                          ], 512), [
                            [_vShow, _ctx.actionType === 'view' && !_ctx.limitEditing]
                          ]),
                          _withDirectives(_createVNode(_component_a_radio_group, {
                            value: _ctx.formData.oilProhibitFlag,
                            "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.oilProhibitFlag) = $event)),
                            onChange: _ctx.oilProhibitChange
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_radio, { value: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("不限制")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_radio, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("限制")
                                ]),
                                _: 1
                              }),
                              _withDirectives(_createElementVNode("div", null, [
                                (_ctx.oilNosList.qy.length)
                                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                                      key: 0,
                                      label: "汽油",
                                      style: {"margin-top":"24px"},
                                      "label-col": { span: 5 }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_checkbox_group, {
                                          value: _ctx.formData.qyNos,
                                          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.qyNos) = $event)),
                                          class: "custom-checkbox",
                                          onChange: _ctx.qyChange
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oilNosList.qy, (item) => {
                                              return (_openBlock(), _createBlock(_component_a_checkbox, {
                                                key: item.oilNo,
                                                value: item.oilNo
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.oilName), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["value", "onChange"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.oilNosList.cy.length)
                                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                                      key: 1,
                                      label: "柴油",
                                      "label-col": { span: 5 }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_checkbox_group, {
                                          value: _ctx.formData.cyNos,
                                          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.cyNos) = $event)),
                                          class: "custom-checkbox",
                                          onChange: _ctx.cyChange
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oilNosList.cy, (item) => {
                                              return (_openBlock(), _createBlock(_component_a_checkbox, {
                                                key: item.oilNo,
                                                value: item.oilNo
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.oilName), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["value", "onChange"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.oilNosList.trq.length)
                                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                                      key: 2,
                                      label: "天然气",
                                      "label-col": { span: 5 }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_checkbox_group, {
                                          value: _ctx.formData.trqNos,
                                          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.trqNos) = $event)),
                                          class: "custom-checkbox",
                                          onChange: _ctx.trqChange
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oilNosList.trq, (item) => {
                                              return (_openBlock(), _createBlock(_component_a_checkbox, {
                                                key: item.oilNo,
                                                value: item.oilNo
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.oilName), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["value", "onChange"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ], 512), [
                                [_vShow, _ctx.formData.oilProhibitFlag]
                              ])
                            ]),
                            _: 1
                          }, 8, ["value", "onChange"]), [
                            [_vShow, !(_ctx.actionType === 'view' && !_ctx.limitEditing)]
                          ])
                        ]),
                        _: 1
                      }, 8, ["rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "车辆支付上限",
                        name: "singleLimitAmount"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("div", { class: "checkboxWidth" }, " 每单支付不超过 " + _toDisplayString(_ctx.formatCny((_ctx.formData.singleLimitAmount).toString())) + " 元 ", 513), [
                              [_vShow, _ctx.formData.singleLimitAmountStatus]
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_25, " 每单无上限 ", 512), [
                              [_vShow, !(_ctx.formData.singleLimitAmountStatus)]
                            ]),
                            _withDirectives(_createElementVNode("div", { class: "checkboxWidth" }, " 每日支付不超过 " + _toDisplayString(_ctx.formatCny((_ctx.formData.dayLimitAmount).toString())) + " 元 ", 513), [
                              [_vShow, _ctx.formData.dayLimitAmountStatus]
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_26, " 每日无上限 ", 512), [
                              [_vShow, !(_ctx.formData.dayLimitAmountStatus)]
                            ])
                          ], 512), [
                            [_vShow, _ctx.actionType === 'view' && !_ctx.limitEditing]
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.formData.singleLimitAmountStatus,
                              "onUpdate:checked": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.singleLimitAmountStatus) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("每单支付不超过")
                              ]),
                              _: 1
                            }, 8, ["checked"]),
                            _createVNode(_component_app_input_number, {
                              value: _ctx.formData.singleLimitAmount,
                              "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.singleLimitAmount) = $event)),
                              suffix: "元",
                              style: {"width":"180px"},
                              disabled: !_ctx.formData.singleLimitAmountStatus,
                              placeholder: "请输入正整数金额"
                            }, null, 8, ["value", "disabled"])
                          ], 512), [
                            [_vShow, !(_ctx.actionType === 'view' && !_ctx.limitEditing)]
                          ])
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createVNode(_component_a_form_item, {
                        label: "   ",
                        class: "ant-form-item-label-no-content",
                        name: "dayLimitAmount"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.formData.dayLimitAmountStatus,
                              "onUpdate:checked": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.dayLimitAmountStatus) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("每日支付不超过")
                              ]),
                              _: 1
                            }, 8, ["checked"]),
                            _createVNode(_component_app_input_number, {
                              value: _ctx.formData.dayLimitAmount,
                              "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.dayLimitAmount) = $event)),
                              suffix: "元",
                              style: {"width":"180px"},
                              disabled: !_ctx.formData.dayLimitAmountStatus,
                              placeholder: "请输入正整数金额"
                            }, null, 8, ["value", "disabled"])
                          ])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, !(_ctx.actionType === 'view' && !_ctx.limitEditing)]
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["editing", "edit-state", "hide-controls", "onCancel", "onSubmit"]),
            (_ctx.energyType !== 2)
              ? (_openBlock(), _createBlock(_component_app_section, {
                  key: 0,
                  title: "车辆制度",
                  "allow-edit": "",
                  editing: _ctx.basicEditing,
                  "edit-state": !(_ctx.editingBlock && _ctx.editingBlock !== 'basic'),
                  "hide-controls": _ctx.actionType === 'create',
                  onEdit: _cache[28] || (_cache[28] = ($event: any) => (_ctx.editingBlock = 'basic')),
                  onCancel: _ctx.onCancelEditBlock,
                  onSubmit: _ctx.onSubmit
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "油补制度" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.formData.title), 513), [
                          [_vShow, !_ctx.basicEditing]
                        ]),
                        _withDirectives(_createVNode(_component_a_select, {
                          value: _ctx.formData.supplementRestrictId,
                          "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.supplementRestrictId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemList, (item) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: item.id,
                                value: item.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"]), [
                          [_vShow, _ctx.basicEditing]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["editing", "edit-state", "hide-controls", "onCancel", "onSubmit"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_29, [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: _ctx.cancelOnAdd
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 512), [
              [_vShow, _ctx.actionType === 'create']
            ])
          ]),
          _: 1
        }, 8, ["model", "rules", "label-col", "wrapper-col"]),
        (_ctx.actionType === 'view' && !_ctx.editingBlock)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              class: "autoEditorView__delBtn",
              type: "primary",
              ghost: "",
              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.visible = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除车辆")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_a_modal, {
        class: "noneFooterBorder",
        title: "删除车辆",
        visible: _ctx.visible,
        "destroy-on-close": true,
        "ok-button-props": { type: 'primary' },
        onCancel: _ctx.closeModel,
        onOk: _ctx.sureChangeModelClick
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_QuestionCircleFilled, { class: "modal-icon-text" }),
            ((_ctx.recordData.num || 0) > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.recordData.licensePlate || _ctx.recordData.vin) + "仍有员工，是否继续删除？ ", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" 确认 删除该车辆？ ")
                ], 64))
          ])
        ]),
        _: 1
      }, 8, ["visible", "onCancel", "onOk"]),
      _createVNode(_component_a_modal, {
        visible: _ctx.previewVisible,
        footer: null,
        onCancel: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            alt: "example",
            style: {"width":"100%"},
            src: _ctx.previewImage
          }, null, 8, _hoisted_30)
        ]),
        _: 1
      }, 8, ["visible", "onCancel"])
    ]),
    _: 1
  }, 8, ["title", "visible", "onClose"]))
}